"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Base64URL = void 0;
var Base64URL = /** @class */ (function () {
    function Base64URL() {
    }
    Base64URL.stringify = function (a) {
        var base64string = btoa(String.fromCharCode.apply(0, a));
        return base64string.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    };
    Base64URL.parse = function (s) {
        s = s.replace(/-/g, '+').replace(/_/g, '/').replace(/\s/g, '');
        return new Uint8Array(Array.prototype.map.call(atob(s), function (c) { return c.charCodeAt(0); }));
    };
    return Base64URL;
}());
exports.Base64URL = Base64URL;
//# sourceMappingURL=base64url.js.map